import { render, staticRenderFns } from "./AmountByPublipostage.vue?vue&type=template&id=4c18c339&scoped=true&"
import script from "./AmountByPublipostage.vue?vue&type=script&lang=js&"
export * from "./AmountByPublipostage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c18c339",
  null
  
)

export default component.exports